import { inject, Injectable } from '@angular/core';
import { Storage } from '@angular/fire/storage';
import { PICTURES_STORAGE } from './api-client.tokens';
import { ApiFireStorageClient } from './api-firestorage-client.service';

@Injectable()
export class ApiFireStoragePicturesClient extends ApiFireStorageClient {
	private readonly picturesStorage = inject(PICTURES_STORAGE);

	protected override getStorage(): Storage {
		if (!this.picturesStorage) {
			throw new Error('Pictures storage is not configured');
		}

		return this.picturesStorage;
	}
}
